module.exports = __webpack_public_path__ + "img/mood.bf78ceb9.png";